import React from 'react'
import style from './Drama.module.css'

function MusicBar({ d, active, isplaying }: { d: { epi_id: string }, active: { epi_id: string } | null, isplaying: boolean }) {
    return (
        <div
            className={style.musicbar}
            style={{
                display: `${active?.epi_id == d.epi_id ? "flex" : "none"}`,
            }}
        >
            <span
                className={style.bar}
                style={{
                    animationPlayState: `${isplaying ? "running" : "paused"}`,
                }}
            ></span>
            <span
                className={style.bar}
                style={{
                    animationPlayState: `${isplaying ? "running" : "paused"}`,
                }}
            ></span>
            <span
                className={style.bar}
                style={{
                    animationPlayState: `${isplaying ? "running" : "paused"}`,
                }}
            ></span>
            <span
                className={style.bar}
                style={{
                    animationPlayState: `${isplaying ? "running" : "paused"}`,
                }}
            ></span>
            <span
                className={style.bar}
                style={{
                    animationPlayState: `${isplaying ? "running" : "paused"}`,
                }}
            ></span>
        </div>
    )
}

export default MusicBar